module.exports = __webpack_public_path__ + "static/media/video_store_coming_soon.eef6ef46.png";